import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Notifications = lazy(() => import('../../pages/Notifications/NotificationsPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<Notifications />} />
    </Routes>
  );
}

export default PagesRoute;
